import { ButtonLink, Icon, IconButton } from '@pm/ui';
import { FunctionComponent } from 'react';
import { To } from 'react-router';

type ButtonProps = {
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
  lastPath?: never;
};

type LinkProps = {
  lastPath?: To;
  onClick?: never;
  disabled?: never;
  className?: string;
};

type Props = ButtonProps | LinkProps;

export const BackArrow: FunctionComponent<Props> = ({
  disabled = false,
  onClick,
  lastPath: to,
}) => {
  const ariaLabel = 'Back Button';

  if (to) {
    return (
      <ButtonLink
        to={to}
        aria-label={ariaLabel}
        width="fit"
        intent="ghost"
        purpose="icon"
        size="xSmall"
      >
        <Icon name="arrow_back" />
      </ButtonLink>
    );
  }

  return (
    <IconButton
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
      width="fit"
      intent="ghost"
      size="xSmall"
    >
      <Icon name="arrow_back" />
    </IconButton>
  );
};
